import request from '../../../helpers/request';

const changeHouseAttachment = async ({ id, attachId, data }) => {
  return await request.put(
    `/HousingStock/house/${id}/attachment/${attachId}`,
    data,
    'При изменении данных документа произошла ошибка'
  );
};

export default changeHouseAttachment;
